import styles from './MachineDetail.module.css';
import { useTranslation } from 'react-i18next';
import MyButton from '../../../../../UI/myButton/MyButton';
import { Box, ClickAwayListener, Tooltip, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import InfoTooltip from '../../../../../UI/InfoTooltip/InfoTooltip';
import useHttp from '../../../../../../hooks/use-http';
import { urls } from '../api/urls';

const MachineDetali = ({ machine, handleOpenDialog }) => {
  const { t, i18n } = useTranslation();
  const [openToolTip, setOpenToolTip] = useState(false);
  const [openToolTipAlat, setOpenToolTipAlat] = useState(false);
  const [openToolTipProizvodi, setOpenToolTipProizvodi] = useState(false);
  const [openToolTipKaraktersitike, setOpenToolTipKarakteristike] =
    useState(false);
  const { getData } = useHttp('');
  const [karakteristikeArr, setKarakteristikeArr] = useState([]);

  const handleToolTip = () => {
    setOpenToolTip((curr) => {
      return !curr;
    });
  };

  const getMachineDetails = async (id) => {
    const config = {
      url: urls.GET_MASINA_ZA_ID,
      method: 'POST',
      data: {
        id: id,
        metadata: 'en-US',
      },
    };

    const response = await getData(config);
    if (response) {
      if (response.listaKarakteristika?.length > 0) {
        setKarakteristikeArr(response.listaKarakteristika);
      }
    }
  };
  useEffect(() => {
    if (machine.id > 0) {
      getMachineDetails(machine.id);
    }
  }, [machine.id]);

  return (
    <div className={styles.machineDetailContainer}>
      <ClickAwayListener onClickAway={() => setOpenToolTip(false)}>
        <Tooltip
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: 'common.white',
                color: 'common.black',
                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)', // Dodavanje box-shadow efekta
                mr: '5px',
                // marginRight: '10px',
              },
            },
          }}
          PopperProps={{
            disablePortal: true,
          }}
          placement="bottom"
          onClose={() => setOpenToolTip(false)}
          open={openToolTip}
          // arrow
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={
            <Box component="span" p={1} width="300px">
              <Typography my={2} sx={{ whiteSpace: 'pre-wrap' }}>
                {machine.dodatneInformacije}
              </Typography>
              {/* <FormControlLabel label={text} /> */}
            </Box>
          }
        >
          <i
            style={{
              fontSize: '40px',
              position: 'absolute',
              right: '4px',
              top: '4px',
              color: '#ed8448',
            }}
            className="fas fa-info-circle"
            onClick={handleToolTip}
          />
        </Tooltip>
      </ClickAwayListener>
      {localStorage.idFirme === '1' ? (
        <div className={styles.textContainer} style={{ width: '30%' }}>
          {/* <p>
            <strong>{t('name')}:</strong> {machine.naziv}
          </p> */}
          <p>
            <strong>
              {`${
                machine.tipMasine === 'Robot' ? t('robotTag') : t('moldTag')
              }:`}
            </strong>{' '}
            {machine.sifra}
          </p>
          <p>
            <strong>{t('machineType')} :</strong> {machine.tipMasine}
          </p>

          <p>
            <strong>{t('machine')} :</strong>{' '}
            {machine.klijentMasine === null ? '' : machine.klijentMasine}
          </p>
          {machine.tipMasine === 'Robot' ? (
            <p>
              <strong>{t('Alat')} :</strong>{' '}
              {machine.klijentAlat === null ? (
                ''
              ) : (
                <InfoTooltip
                  openToolTip={openToolTipAlat}
                  setOpenToolTip={setOpenToolTipAlat}
                  text={machine.klijentAlat.split(',').join('\n')}
                />
              )}
            </p>
          ) : null}
          <p>
            <strong>{t('product')} :</strong>{' '}
            {machine.klijentProizvodi === null ? (
              ''
            ) : (
              <InfoTooltip
                openToolTip={openToolTipProizvodi}
                setOpenToolTip={setOpenToolTipProizvodi}
                text={machine.klijentProizvodi.split(',').join('\n')}
              />
            )}
          </p>
          <p>
            <strong>{t('characteristics')} :</strong>{' '}
            {karakteristikeArr?.length === 0 ? (
              ''
            ) : (
              <InfoTooltip
                openToolTip={openToolTipKaraktersitike}
                setOpenToolTip={setOpenToolTipKarakteristike}
                text={karakteristikeArr.map((item) => (
                  <span>
                    <b>{item.naziv}</b>: {item.opis}
                    <br />
                  </span>
                  // `<b>${item.naziv}</b>: ${item.opis}\n`;
                ))}
              />
            )}
          </p>
          <p>
            <strong>{`${
              machine.tipMasine === 'Robot'
                ? t('internRobotTag')
                : t('internMoldTag')
            }:`}</strong>{' '}
            {machine.oznakaKupac}
          </p>
          <p>
            <strong>{t('location')}:</strong> {machine.lokacija}
          </p>
          {+localStorage.idFirme === 1 && (
            <p>
              <strong>{t('client')}:</strong> {machine.kupac}
            </p>
          )}
          {/* <p>
          <strong>Klijent:</strong> {machine.kupac}
        </p> */}
        </div>
      ) : (
        <div className={styles.textContainer}>
          <p>
            <strong>{`${
              machine.tipMasine === 'Robot'
                ? t('internRobotTag')
                : t('internMoldTag')
            }:`}</strong>{' '}
            <span>{machine.oznakaKupac}</span>
          </p>
          <p style={{ width: 'fit-content', backgroundColor: '#e9e8e8' }}>
            <strong>{` ${
              machine.tipMasine === 'Robot' ? t('robotTag') : t('moldTag')
            }:`}</strong>{' '}
            <span>{machine.sifra}</span>
          </p>
          <p>
            <strong>{t('machine')} :</strong>{' '}
            {machine.klijentMasine === null ? '' : machine.klijentMasine}
          </p>
          {machine.tipMasine === 'Robot' ? (
            <p>
              <strong>{t('Alat')} :</strong>{' '}
              {machine.klijentAlat === null ? (
                ''
              ) : (
                <InfoTooltip
                  openToolTip={openToolTipAlat}
                  setOpenToolTip={setOpenToolTipAlat}
                  text={machine?.klijentAlat?.split(',').join('\n')}
                />
              )}
            </p>
          ) : null}
          <p>
            <strong>{t('product')} :</strong>{' '}
            {machine.klijentProizvodi === null ? (
              ''
            ) : (
              <InfoTooltip
                openToolTip={openToolTipProizvodi}
                setOpenToolTip={setOpenToolTipProizvodi}
                text={machine?.klijentProizvodi?.split(',').join('\n')}
              />
            )}
          </p>
          <p>
            <strong>{t('characteristics')} :</strong>{' '}
            {karakteristikeArr?.length === 0 ? (
              ''
            ) : (
              <InfoTooltip
                openToolTip={openToolTipKaraktersitike}
                setOpenToolTip={setOpenToolTipKarakteristike}
                text={karakteristikeArr.map((item) => (
                  <span>
                    <b>{item.naziv}</b>: {item.opis}
                    <br />
                  </span>
                  // `<b>${item.naziv}</b>: ${item.opis}\n`;
                ))}
              />
            )}
          </p>
          {/* <p>
            <strong>{t('name')}</strong> {machine.naziv}
          </p> */}
          <p>
            <strong>{t('machineType')} :</strong> {machine.tipMasine}
          </p>

          <p>
            <strong>{t('location')}:</strong> {machine.lokacija}
          </p>
          <MyButton
            onClick={handleOpenDialog}
            label={t('buttons.changeInternalTag')}
            icon="fas fa-edit"
            style={{ backgroundColor: '#ed8448', color: 'white' }}
          />
        </div>
      )}

      <div className={styles.contactContainer}>
        <strong className={styles.title}>{t('contactPerson')}</strong>

        <label style={{ fontWeight: 'bold' }}>
          {machine.kontaktOsoba
            ? machine.kontaktOsoba
            : 'Nema definisana kontakt osoba'}
        </label>

        <label style={{ textWrap: 'nowrap' }}>
          <i style={{ marginRight: '10px' }} className="fas fa-phone-alt" />
          {machine.kontaktTelefon
            ? machine.kontaktTelefon
            : 'Nema definisan kontakt telefon'}
        </label>

        <label style={{ textWrap: 'nowrap' }}>
          <i style={{ marginRight: '10px' }} className="fas fa-envelope" />
          {machine.email ? machine.email : 'Nema definisan email'}
        </label>
      </div>

      <div className={styles.imageContainer}>
        <img
          src={machine.slikaUrl}
          alt={`${machine.naziv}`}
          className={styles.machineImage}
        />
        {/* <button className={styles.replaceImageButton}>
          {t('replaceImage')}
        </button> */}
      </div>
      {/* {localStorage.idFirme !== '1' && (
        <MyButton
          onClick={handleOpenDialog}
          label={t('buttons.changeInternalTag')}
          icon="fas fa-edit"
          style={{
            width: '230px',
            backgroundColor: '#ed8448',
            color: 'white',
            marginTop: 'auto',
          }}
        />
      )} */}
    </div>
  );
};

export default MachineDetali;
